import React, { PureComponent, MouseEvent  } from 'react'
import { connect, ConnectedProps } from 'react-redux'

import Modal from 'components/Common/Modal/Modal'
import Button from 'components/Common/Buttons/Button/Button'
import { ReactComponent as LogoIcon } from 'assets/images/icons/logo.svg'

import { withTranslation, WithTranslation } from 'react-i18next'

import { downloadImage } from 'helpers/downloadImage'

import { imageConvertAction } from 'store/actions/image.actions'
import { showLoader } from 'store/actions/loader.actions'
import { setImageStatus } from 'store/actions/settings.actions'

import './Logo.scss'

/* TODO: Typings */

type LogoState = {
  isOpenModal: boolean
}

type ImageStore = {
  imageSrc: string,
  imageData: ImageData,
  imageFormat: string
}

type CropperStore = {
  cropper: {
    changed: boolean
  }
}

type ResizeStore = {
  resize: {
    changed: boolean
  }
}

type SettingStore = {
  settingsList: Array<object>,
  currentSettingId: number
}

type MapStateToProps = {
  imageStore: ImageStore,
  settingsStore: SettingStore,
  cropperStore: CropperStore,
  resizeStore: ResizeStore
}


const mapStateToProps = ({
  imageStore: { 
    imageSrc, 
    imageData, 
    imageFormat,
  },
  settingsStore: { 
    settingsList, 
    currentSettingId 
  },
  cropperStore: {
    cropper
  },
  resizeStore: {
    resize
  }
} : MapStateToProps)  => ({
  imageSrc,
  settingsList,
  imageData,
  imageFormat,
  currentSettingId,
  cropper,
  resize
})

const mapDispatchToProps = ({
  dispatchImageConvert: (data: {format: string, image: Blob}) => imageConvertAction({ data }),
  dispatchShowLoader: () => showLoader(),
  dispatchSetImageStatus: () => setImageStatus(),
})

const connector = connect(mapStateToProps, mapDispatchToProps)

type PropsFromRedux = ConnectedProps<typeof connector>

type LogoProps = WithTranslation & PropsFromRedux

class Logo extends PureComponent<LogoProps, LogoState> {
  constructor(props: LogoProps) {
    super(props)

    this.state = {
      isOpenModal: false
    }

  }

  onCloseModal = () => {
    this.setState({ isOpenModal: false })
  }

  onOpenModal = () => {
    this.setState({ isOpenModal: true })
  }

  onLogoClick = (evt: MouseEvent<HTMLAnchorElement>) => {
    const { 
      settingsList, 
      imageSrc,
      resize,
      cropper
    } = this.props

    if (imageSrc && settingsList.length > 0 || resize.changed || cropper.changed) {
      evt.preventDefault()
      this.onOpenModal()
    } 
  }

  onClickLeavePageButton = (url: string) => {  
    this.onCloseModal()
    window.location.href = url
  }

  onClickDownloadButton = () => {

    const {
      imageData, 
      imageFormat,
      settingsList, 
      currentSettingId,
      dispatchImageConvert,
      dispatchShowLoader,
    } = this.props

    dispatchShowLoader()

    const { base64 } = downloadImage({ imageData, settingsList, currentSettingId })

    /* TODO Type */
    this.onCloseModal()
    dispatchImageConvert({ format: imageFormat, image: base64}  as any)
  }

  onReloadPage = (evt: any) => {
    // https://stackoverflow.com/questions/33860241/safari-back-button-doesnt-reload-page-when-used
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
    if (isSafari && evt.persisted) {
      setTimeout(() => {
        window.location.reload()
      }, 10)
    }
  }

  componentDidMount() {
    window.addEventListener('pageshow', this.onReloadPage, false)
  }

  componentWillUnmount() {
    window.removeEventListener('pageshow', this.onReloadPage, false)
  }


  render() {
    const { t } = this.props

    const { isOpenModal } = this.state

    const urlPicverse = this.props.i18n.language === 'ru' ? 'https://www.picverse.com/ru' : 'https://www.picverse.com/'

    return (
      <>
        <a 
          className="logo" 
          href={urlPicverse}
          onClick={this.onLogoClick}
        >
          <LogoIcon className="logo__image" />
          Movavi Picverse
        </a>

        <Modal isOpen={isOpenModal} onCloseModal={this.onCloseModal}>
          <div className="modal__body">
            <div className="modal__title">{t('modals.leave-page-title')}</div>
            {t('modals.leave-page-text')}
          </div>
          <div className="modal__buttons">
            <Button variant="ghost" onClick={() => this.onClickLeavePageButton(urlPicverse)}>
              {t('buttons.leave-page')}
            </Button>
            <div className="modal__buttons-separator" />
            <Button onClick={this.onClickDownloadButton}>
              {t('buttons.download')}
            </Button>
          </div>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(connector(Logo))
